import { useNavigationConfig } from '@/components/theme-layouts/components/navigation/hooks/useNavigationConfig';
import { setNavigation } from '@/components/theme-layouts/components/navigation/store/navigationSlice';
import { useAppDispatch } from '@/store/hooks';
import useAuth from '@fuse/core/FuseAuthProvider/useAuth';
import { useEffect } from 'react';

/**
 * NavigationConfigListener
 * A component that uses the useNavigationConfig hook to automatically update navigation
 * when configuration changes. This ensures that navigation items are hidden/shown 
 * based on configuration settings in real-time.
 * 
 * Only fetches navigation configs when the user is authenticated.
 */
function NavigationConfigListener() {
    const dispatch = useAppDispatch();
    const { authState } = useAuth();
    const isAuthenticated = authState?.isAuthenticated;
    const authStatus = authState?.authStatus;

    // Only fetch navigation config when authenticated AND auth is not in configuring state
    // This prevents race conditions on page refresh
    const shouldFetchConfigs = isAuthenticated && authStatus !== 'configuring' && authStatus !== 'loading';
    const { navigation } = useNavigationConfig(shouldFetchConfigs);

    // Update navigation in Redux store whenever the filtered navigation changes
    // Only when user is authenticated
    useEffect(() => {
        if (isAuthenticated && authStatus === 'authenticated') {
            dispatch(setNavigation(navigation));
        }
    }, [navigation, dispatch, isAuthenticated, authStatus]);

    // This component doesn't render anything
    return null;
}

export default NavigationConfigListener;